import styles from './styles.module.css';
import { ErrorMessage } from '../ErrorMessage';
import clsx from 'clsx';
import { WisoryLabel } from '../WisoryLabel';

type Props = {
  label?: string;
  className?: string;
  errorMessage?: string;
  extra?: string;
  layout?: 'vertical' | 'horizontal';
};

export const FormItem = ({
  label,
  errorMessage,
  extra,
  className = '',
  layout = 'vertical',
  children,
}: React.PropsWithChildren<Props>) => {
  if (layout === 'horizontal') {
    return (
      <div className={clsx('w-full flex items-center', className)}>
        {label && (
          <WisoryLabel className={clsx('w-1/3', { [styles.mark]: errorMessage })}>
            {label}
            {errorMessage && '* '}
          </WisoryLabel>
        )}
        {extra && <p className={clsx(styles.extra, 'font-openSans')}>{extra}</p>}
        <div className={clsx(styles.control, 'w-2/3', { [styles.error]: errorMessage })}>
          {children}
          <ErrorMessage>{errorMessage}</ErrorMessage>
        </div>
      </div>
    );
  }

  return (
    <div className={clsx(styles.wrapper, 'w-full', className)}>
      {label && (
        <WisoryLabel className={clsx('mb-2', { [styles.mark]: errorMessage })}>
          {label}
          {errorMessage && '* '}
        </WisoryLabel>
      )}
      {extra && <p className={clsx(styles.extra, 'font-openSans')}>{extra}</p>}
      <div className={clsx(styles.control, { [styles.error]: errorMessage })}>
        {children}
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </div>
    </div>
  );
};
